"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PonziBalanceDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const icons_material_1 = require("@mui/icons-material");
const wagmi_1 = require("wagmi");
const viem_1 = require("viem");
const react_query_1 = require("@tanstack/react-query");
const mui_page_layout_1 = require("@dzambalaorg/mui-page-layout");
const mui_dialog_confirmation_1 = require("@dzambalaorg/mui-dialog-confirmation");
const provider_api_firebase_1 = require("@dzambalaorg/provider-api-firebase");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const exchange_1 = require("@framework/exchange");
const styled_1 = require("@framework/styled");
const withdrawToken_json_1 = __importDefault(require("@framework/abis/json/Ponzi/withdrawToken.json"));
const common_1 = require("../../../../../common");
const amount_dialog_1 = require("../amount-dialog");
const PONZI_BALANCE_DIALOG_KEY = "ponziBalance";
const PonziBalanceDialog = (props) => {
    const { data, open, ...rest } = props;
    const [withdrawBalance, setWithdrawBalance] = (0, react_1.useState)(common_1.emptyBalance);
    const { openFormDialog, formDialogUniqueKey, mode } = (0, react_hooks_1.useDialogForm)();
    const { address, connector } = (0, wagmi_1.useAccount)();
    const { data: client } = (0, wagmi_1.useWalletClient)();
    const api = (0, provider_api_firebase_1.useApi)();
    const { data: rows = [], isLoading } = (0, react_query_1.useQuery)({
        queryKey: [`/balances/${data.address}`],
        queryFn: async () => {
            return api.fetchJson({
                url: `/balances/${data.address}`,
                method: "GET",
            });
        },
        enabled: open,
    });
    const { execute: metaWithdraw } = (0, react_hooks_eth_1.useMetamask)(async (values, withdrawAmount) => {
        const token = values.token.template.contract.address;
        const provider = await connector.getProvider();
        const publicClient = (0, viem_1.createPublicClient)({
            chain: client.chain,
            transport: (0, viem_1.http)(client.chain.rpcUrls.default.http[0], client.transport),
            pollingInterval: 60000,
        });
        const walletClient = (0, viem_1.createWalletClient)({
            chain: client.chain,
            transport: (0, viem_1.custom)(provider),
        });
        const estimateGas = await publicClient.estimateContractGas({
            address: data.address,
            abi: withdrawToken_json_1.default,
            functionName: "withdrawToken",
            args: [token, withdrawAmount],
            account: address,
        });
        return await walletClient.writeContract({
            address: data.address,
            abi: withdrawToken_json_1.default,
            functionName: "withdrawToken",
            args: [token, withdrawAmount],
            gas: (estimateGas * 110n) / 100n,
            account: address,
        });
    });
    const handleSetAmount = (values) => {
        return () => {
            setWithdrawBalance(values);
            return openFormDialog(PONZI_BALANCE_DIALOG_KEY, void 0, "button");
        };
    };
    const handleWithdraw = async (values, withdrawAmount) => {
        await metaWithdraw(values, withdrawAmount);
    };
    const handleAmountConfirm = async ({ data }) => {
        await handleWithdraw(data.balance, data.amount);
    };
    return ((0, jsx_runtime_1.jsxs)(mui_dialog_confirmation_1.ConfirmationDialog, { open: open, message: "dialogs.ponziBalance", "data-testid": "PonziBalanceDialog", ...rest, children: [(0, jsx_runtime_1.jsx)(mui_page_layout_1.ProgressOverlay, { isLoading: isLoading, children: (0, jsx_runtime_1.jsx)(styled_1.StyledListWrapper, { count: rows.length, isLoading: isLoading, children: rows.map(balance => ((0, jsx_runtime_1.jsxs)(styled_1.StyledListItem, { children: [(0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemText, { sx: { width: 0.6 }, children: balance.token.template.title }), (0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemText, { children: (0, exchange_1.formatEther)(balance.amount, balance.token.template.contract.decimals, balance.token.template.contract.symbol) }), (0, jsx_runtime_1.jsx)(styled_1.ListActions, { children: (0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleSetAmount(balance), icon: icons_material_1.CurrencyExchange, message: "form.buttons.setAmount" }) })] }, balance.id))) }) }), (0, jsx_runtime_1.jsx)(amount_dialog_1.AmountDialog, { onExternalConfirm: handleAmountConfirm, open: formDialogUniqueKey === `${PONZI_BALANCE_DIALOG_KEY}.${mode}`, message: "dialogs.setAmount", testId: "AmountDialogForm", initialValues: {
                    balance: withdrawBalance,
                    amount: withdrawBalance.amount,
                } })] }));
};
exports.PonziBalanceDialog = PonziBalanceDialog;
//# sourceMappingURL=index.js.map